var React = require('react');

function Logstash (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0 0)"},[React.createElement("path",{"d":"M713.762,222.255h-20.17V199h6.09a14.06,14.06,0,0,1,14.08,14.079Z","transform":"translate(-693.513 -199)","fill":"#ccc","key":0}),React.createElement("path",{"d":"M713.78,237.174a20.238,20.238,0,0,1-20.249-20.249H713.78Z","transform":"translate(-693.531 -193.67)","fill":"#231f20","key":1}),React.createElement("path",{"d":"M709.139,216.925h18.429v20.249H709.139Z","transform":"translate(-688.89 -193.67)","fill":"#b3b3b3","key":2}),React.createElement("path",{"d":"M709.139,216.925h4.271v20.249h-4.271Z","transform":"translate(-688.89 -193.67)","fill":"gray","key":3})]));
}

Logstash.defaultProps = {"width":"38.679","height":"43.505","viewBox":"0 0 38.679 43.505"};

module.exports = Logstash;

Logstash.default = Logstash;
